<script>
import ReportTableBox from "@components/reports/EOD/ReportTableBox.vue";

export default {
  components: {ReportTableBox},
  props: {
    editing: Boolean,
    dataTable: {
      type: Array,
      default: []
    },
  },
  computed: {
    total() {
      return this.dataTable.reduce((acc, item) => acc + item.amount, 0);
    }
  },
  data() {
    return {
      localDataTable: this.dataTable
    }
  },
  watch: {
    localDataTable: {
      handler() {
        this.$emit("updateDataTable", this.localDataTable);
      },
      deep: true
    }
  }
}
</script>

<template>
  <ReportTableBox title="Service Types">
    <DataTable :value="dataTable" size="small" class="custom-table w-full">
      <Column field="type">
        <template #header>
          <span class="md:pl-4 pl-0 font-semibold">Service</span>
        </template>
        <template #body="slotProps">
          <span class="md:pl-4 pl-0">{{ slotProps.data.type }}</span>
        </template>
      </Column>
      <Column field="amount">
        <template #header>
          <div class="flex justify-end items-center w-full md:pr-4 pr-0">
            <span class="text-end font-semibold">Amt</span>
          </div>
        </template>
        <template #body="{data, field}">
          <div class="flex justify-end items-center w-full md:pr-4 pr-0">
            <InputNumber :min="0" v-if="editing" class="sleek-input" v-model="data[field]" autofocus fluid/>
            <span v-else class="m-0">
            {{ data[field] }}
          </span>
          </div>
        </template>
      </Column>
      <ColumnGroup type="footer">
        <Row>
          <Column>
            <template #footer>
              <span class="font-semibold md:pl-4 pl-0">Total</span>
            </template>
          </Column>
          <Column>
            <template #footer>
              <div class="flex justify-end items-center w-full md:pr-4 pr-0">
                <span class="font-semibold text-center">{{ total }}</span>
              </div>
            </template>
          </Column>
        </Row>
      </ColumnGroup>
    </DataTable>
  </ReportTableBox>
</template>